// ═══════════════════════════════════════════════════════════════
// NOTIFICATION TYPES
// ═══════════════════════════════════════════════════════════════

export type NotificationType =
  | 'message'
  | 'system_message'
  | 'application_update'
  | 'job_match'
  | 'auto_apply'
  | 'profile_view'
  | 'interview'
  | 'nova_approval'
  | 'nova_result'
  | 'nova_failed'
  | 'nova_paused'
  | 'report_update'
  | 'system';

export interface NotificationSummary {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string | null;
  data: Record<string, unknown>;
  read: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationNewEvent {
  notification: NotificationSummary;
}

export interface NotificationCountEvent {
  count: number;
}

export interface DeviceTokenPayload {
  token: string;
  platform: 'ios' | 'android' | 'web';
}

export interface NotificationPreferences {
  marketingEmailsEnabled: boolean;
  systemEmailsEnabled: boolean;
  pushNotificationsEnabled: boolean;
}

export type NotificationPreferencesPatch = Partial<NotificationPreferences>;

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  marketingEmailsEnabled: true,
  systemEmailsEnabled: true,
  pushNotificationsEnabled: true,
};

/**
 * Company identity carried on a job-scoped notification's `data`.
 *
 * Written at creation time rather than resolved per row: `data` is the only job
 * context a notification keeps, and the list would otherwise need one job-detail
 * request per row to name the employer. Every field is optional - notifications
 * created before this contract, and every non-job type, carry none of it.
 *
 * `matchScore` is the catalog fraction (0-1), not a percentage.
 */
export interface NotificationJobCompanyData {
  companyName?: string | null;
  companyLogo?: string | null;
  companyLocation?: string | null;
  matchScore?: number | null;
}
